<script setup lang="ts">
import { ExclamationCircleIcon } from "@heroicons/vue/20/solid";

import { useUser } from "@/composables/api/useUser";

import Dialog from "@/components/ui/Dialog.vue";

const { data: user } = useUser();
</script>

<template>
  <!-- Lactel variant -->
  <div
    v-if="user?.current_mechanic === 'lactel'"
    class="flex w-full max-w-xs flex-col items-center gap-8 overflow-visible rounded-[20px] bg-[#001065] px-5 pt-10 pb-10 lg:max-w-[594px] lg:px-10"
  >
    <div class="flex flex-col items-center gap-5">
      <h3
        class="font-mitr px-4 text-center text-4xl font-bold text-[#FAE154] lg:px-10 lg:text-5xl"
        v-html="$t('bigDraw.title')"
      />

      <p
        class="font-montserrat px-4 text-center text-lg font-semibold text-white lg:px-10 lg:text-xl"
        v-html="$t('bigDraw.subtitle')"
      />
    </div>

    <div
      class="-mr-9 -ml-9 flex w-[calc(100%+72px)] flex-col overflow-clip rounded-[20px] shadow-[0px_0px_20px_0px_rgba(0,0,0,0.14)] lg:-mr-16 lg:-ml-16 lg:w-[calc(100%+128px)]"
    >
      <div class="flex flex-col items-center bg-[#fff296] px-4 pt-6 pb-4">
        <img
          src="/lactel/images/wonderbox_1.png"
          alt=""
          class="pointer-events-none mt-4 h-[200px] w-[160px] object-contain lg:h-[308px] lg:w-[246px]"
        />
      </div>

      <div class="flex flex-col items-center gap-3 bg-white py-6 lg:gap-5">
        <p
          class="font-mitr px-4 text-center text-xl font-semibold text-balance text-[#001065] lg:text-[32px] lg:leading-[1.2]"
          v-html="$t('bigDraw.prize.title')"
        />

        <Dialog>
          <template #trigger>
            <button
              type="button"
              class="flex cursor-pointer items-center gap-1 text-center text-sm text-[#6578a7] underline lg:text-xl"
            >
              <ExclamationCircleIcon class="size-5 rotate-180 lg:size-7" />
              {{ $t("bigDraw.prize.seeMore") }}
            </button>
          </template>

          <template #content>
            <div class="flex w-full flex-col gap-5">
              <h2 class="text-2xl leading-tight font-semibold text-[#001065]">
                {{ $t("dialog.bigDraw.title") }}
              </h2>

              <div
                class="text-secondary flex w-full flex-col gap-4 text-base font-medium"
                v-html="$t('dialog.bigDraw.content')"
              />
            </div>
          </template>
        </Dialog>
      </div>
    </div>
  </div>

  <!-- Default (Galbani) variant -->
  <div
    v-else
    class="flex w-full max-w-xs flex-col items-center gap-5 rounded-[20px] bg-black pt-5 pb-8 shadow-md lg:max-w-lg lg:pb-10"
  >
    <div class="flex flex-col items-center gap-5">
      <h3
        class="font-brygada text-topchef px-4 text-center text-4xl font-bold lg:px-10 lg:text-5xl"
        v-html="$t('bigDraw.title')"
      />
    </div>

    <div
      class="relative -mr-4 -ml-4 flex w-[calc(100%+32px)] flex-col rounded-[20px] bg-white shadow-xl lg:-mr-8 lg:-ml-8 lg:w-[calc(100%+64px)]"
    >
      <img
        src="/images/big-draw-cover.png"
        alt=""
        class="pointer-events-none h-56 w-full rounded-t-[20px] object-cover lg:h-96"
      />

      <div class="flex flex-col items-center gap-3 rounded-b-[20px] py-3 lg:gap-5 lg:py-6">
        <p
          class="text-galbani font-brygada text-center text-xl font-bold text-balance lg:text-[32px]"
          v-html="$t('bigDraw.prize.title')"
        />

        <Dialog>
          <template #trigger>
            <button
              type="button"
              class="text-secondary flex cursor-pointer items-center gap-1 text-center text-sm underline lg:text-xl"
            >
              <ExclamationCircleIcon class="size-5 rotate-180 lg:size-6" />
              {{ $t("bigDraw.prize.seeMore") }}
            </button>
          </template>

          <template #content>
            <div class="flex w-full flex-col gap-5">
              <h2 class="text-galbani text-2xl leading-tight font-semibold">
                {{ $t("dialog.bigDraw.title") }}
              </h2>

              <div
                class="text-secondary flex w-full flex-col gap-4 text-base font-medium"
                v-html="$t('dialog.bigDraw.content')"
              />
            </div>
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
